import React from 'react'
import FormFieldController from '../../../Components/FormFieldController'
import { generateTimeOptions } from '../../GuestBooking/utils/formatters'

const timeOptions = generateTimeOptions().map(t => ({ value: t, label: t }))

export default function BookingForm({ control, errors, venues = [], packages = [] }) {
  const venueOptions = [
    { value: '', label: 'No venue' },
    ...venues.map(v => ({ value: v.id, label: v.name }))
  ]

  const packageOptions = [
    { value: '', label: 'No package' },
    ...packages.map(p => ({ value: p.id, label: p.name }))
  ]

  return (
    <>
      <FormFieldController
        control={control}
        name="guest_name"
        label="Guest Name"
        required
        errors={errors}
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FormFieldController
          control={control}
          name="guest_email"
          label="Email"
          type="email"
          required
          errors={errors}
        />

        <FormFieldController
          control={control}
          name="guest_phone"
          label="Phone"
          errors={errors}
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <FormFieldController
          control={control}
          name="date"
          label="Date"
          type="date"
          required
          errors={errors}
        />

        <FormFieldController
          control={control}
          name="time"
          label="Time"
          type="select"
          options={timeOptions}
          required
          errors={errors}
        />

        <FormFieldController
          control={control}
          name="party_size"
          label="Party Size"
          type="number"
          required
          errors={errors}
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FormFieldController
          control={control}
          name="venue_id"
          label="Venue"
          type="select"
          options={venueOptions}
          errors={errors}
        />

        <FormFieldController
          control={control}
          name="package_id"
          label="Package"
          type="select"
          options={packageOptions}
          errors={errors}
        />
      </div>

      <FormFieldController
        control={control}
        name="total_pence"
        label="Total"
        type="currency"
        errors={errors}
        hint="Total price for the booking"
      />

      <FormFieldController
        control={control}
        name="notes"
        label="Guest Notes"
        type="textarea"
        rows={2}
        errors={errors}
      />

      <FormFieldController
        control={control}
        name="internal_notes"
        label="Internal Notes"
        type="textarea"
        rows={2}
        errors={errors}
        hint="Only visible to staff"
      />
    </>
  )
}
